import { useEffect } from 'react';
import { emitMessage, off, subscribe } from '../helpers/subscription';
export var useMessaging = function (name, onNewMessage) {
    useEffect(function () {
        var subscription = subscribe(name, onNewMessage);
        return function () {
            off(subscription);
        };
    }, [name, onNewMessage]);
    return { emit: emitMessage };
};
//# sourceMappingURL=useMessaging.js.map